export default "__VITE_ASSET__CBm1aioW__"